import { render, staticRenderFns } from "./ModulePermissionPopup.vue?vue&type=template&id=63a85731&scoped=true&"
import script from "./ModulePermissionPopup.vue?vue&type=script&lang=ts&"
export * from "./ModulePermissionPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ModulePermissionPopup.vue?vue&type=style&index=0&id=63a85731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a85731",
  null
  
)

export default component.exports